import { render } from "./suggestionsListItem.vue?vue&type=template&id=622e3b56&ts=true"
import script from "./suggestionsListItem.vue?vue&type=script&lang=ts"
export * from "./suggestionsListItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__